import { getUrlQuerysection } from "../../../../helpers";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useGetTrialBalanceReport } from "../../../../hooks/api/queries";
import { useSelector } from "react-redux";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";

export const useAccountingTrialBalance = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { storeHasMultipleCurrency } = useStoreCurrency();
  const [asOfDate, setAsOfDate] = useState(
    searchParams.get("as_of_date") || Date.now(),
  );
  const [currentStore, setCurrentStore] = useState(
    storeHasMultipleCurrency
      ? searchParams.get("store_id") || storeList?.[0]?.id
      : "",
  );
  const queries = getUrlQuerysection();

  const {
    isLoading: isLoadingReport,
    data: reportData,
    refetch: fetchTrialBalanceReport,
  } = useGetTrialBalanceReport({ queries, enabled: false });

  const setDateFilter = (value) => {
    searchParams.set("as_of_date", value);
    setAsOfDate(value);
    setSearchParams(searchParams, { replace: true });
  };

  const filterByStoreId = (storeId) => {
    setCurrentStore(storeId);
    if (storeId === "ALL_STORES" || storeId === "")
      searchParams.delete("store_id");
    else searchParams.set("store_id", storeId);
    setSearchParams(searchParams, { replace: true });
  };

  return {
    asOfDate,
    reportData: reportData?.data || null,
    isLoadingReport,
    storeList,
    storeHasMultipleCurrency,
    currentStore,
    setDateFilter,
    filterByStoreId,
    fetchTrialBalanceReport,
  };
};
